export const faqsSection = () => {
  const $faqsSections = document.querySelectorAll("section.faqs");

  if ($faqsSections) {
    $faqsSections.forEach(($faqSection) => {
      const $faqs = $faqSection.querySelectorAll(".faqs__list .faq");
      $faqs.forEach(($faq) => {
        const $faqQuestion = $faq.querySelector(".faq__question");

        $faqQuestion.addEventListener("click", (event) => {
          event.preventDefault();
          // const $target = event.target;
          // $faqs.forEach(($faqInner) => {
          //   const $faqIconOpen = $faqInner.querySelector(
          //     ".faq__question-icon .faq__question-icon-open"
          //   );
          //   const $faqIconClosed = $faqInner.querySelector(
          //     ".faq__question-icon .faq__question-icon-closed"
          //   );
          //   const $faqAnswer = $faqInner.querySelector(".faq__answer");
          //   $faqIconOpen.classList.add("hidden");
          //   $faqIconClosed.classList.remove("hidden");
          //   $faqAnswer.classList.add("hidden");
          // });

          const $currentFaqOpen = $faq.querySelector(
            ".faq__question-icon .faq__question-icon-open"
          );
          const $currentFaqClosed = $faq.querySelector(
            ".faq__question-icon .faq__question-icon-closed"
          );
          const $faqAnswer = $faq.querySelector(".faq__answer");
          $currentFaqOpen.classList.toggle("hidden");
          $currentFaqClosed.classList.toggle("hidden");
          $faqAnswer.classList.toggle("hidden");
        });
      });
    });
  }
};

export default faqsSection;
